import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { withRouter } from '../withRouter';
import { addToCart } from 'actions/cart';
import styles from './GameVoteStyles.module.scss'
import GameAddonList from "constants/GameAddonList"

class GameVote extends Component {
    static displayName = GameVote.name;

    constructor(props) {
        super(props);

        this.state = {
            game: null,
            gameAddons: this.getAddons(),
        };
    }

    getAddons() {
        return GameAddonList.filter((a) => a.forGameId === this.props.game.gameId).map((a) => {
            const owned = a.price === 0 || (this.props.addons && this.props.addons.find(owendAddon => owendAddon.code === a.addonId) ? true : false);
            return { ...a, owned }
        });
    }

    componentDidMount() {

    }

    getCardStyling() {

        // Bad name of method, this is specific to card background
        return {
            backgroundImage: `url(${this.props.game?.meta.cardBackground})`
        }
    }

    getCardPriceBannerStyling() {
        return {
            background: this.props.game?.meta.cardPriceColour
        }
    }

    getButtonStyling() {
        return {
            background: this.props.game.meta.storeAccentColour
        }
    }

    getAddonText() {
        const ownedCount = this.state.gameAddons.filter(a => a.owned).length;
        const availableCount = this.state.gameAddons.length - ownedCount;
        let text = "Add-ons: "
        text += ownedCount !== 0 ? `${ownedCount} owned` : "";
        if (ownedCount > 0 && availableCount > 0) text += ", "
        text += availableCount !== 0 ? `${availableCount} available` : "";
        return text;
    }

    getAdditionalStyles() {
        if (this.props.game?.name === "Playing With Fire") {
            return {
                width: '75%',
            }
        }
    }
    render() {
        let gameVotes = 0;
        if (this.props.game) gameVotes = this.props.room.players.filter((player) => player.gameVote == this.props.game.gameId).length;
        
        return (
            this.props.game &&
            <div className={`${styles.gameVoteCard} ${this.props.selected && styles.selected} ${!this.props.supported && styles.unsupported}`} style={this.getCardStyling()} onClick={() => this.props.clickEvent(this.props.game)}>
                {
                    this.props.showVotes && gameVotes > 0 &&
                    <div className={styles.votesCounter} style={this.getCardPriceBannerStyling()}><span>{gameVotes}</span></div>
                    }
                    <img src={this.props.game?.meta.cardLogo} className={styles.gameCardLogo} alt={`${this.props.game?.name} logo`} style={this.getAdditionalStyles() }></img>
                    {/*{this.state.gameAddons.length > 0 &&*/}
                    {/*    <div className={styles.availableAddons} style={this.getButtonStyling()}>{this.getAddonText()}</div>*/}
                    {/*}*/}
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        room: state.room,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (game) => {
            dispatch(addToCart(game))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(GameVote));
